module.exports = __webpack_public_path__ + "img/SC-3999.8b956eda.png";